export const CMS_URL = process.env.REACT_APP_CMS_URL || "https://cms.nathabit.in";
export const CMS_AUTH_TOKEN =
  "Bearer ecbbb93b98856c1050b2ab4dbe3b167fa35b179e5f876c428e246002d3faee9bbc9639122499fbdbf06e55c2fcc3e18887cfb0abb99a4c4be233ed2abe78db0d6ef90991b719917b3c3cdb918c232fdd38dcab03de53b8a8fe601dd1708dda37fd5302b41214a3a8c6e123592e2616257ad7ce894fe33a1f0f20a5b4f89d1ed3";
